import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-24 px-4 sm:px-0" }
const _hoisted_2 = { class: "mt-4 flex flex-row items-center justify-between" }
const _hoisted_3 = { class: "text-2xl text-gray-600 font-body" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Add", -1)
const _hoisted_5 = {
  key: 0,
  class: "py-16 text-gray-500 flex flex-col items-center justify-center"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "flex flex-row items-center"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AddIcon = _resolveComponent("AddIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_BudgetTableHeaders = _resolveComponent("BudgetTableHeaders")
  const _component_CardHeader = _resolveComponent("CardHeader")
  const _component_WarningIcon = _resolveComponent("WarningIcon")
  const _component_EditIcon = _resolveComponent("EditIcon")
  const _component_BanIcon = _resolveComponent("BanIcon")
  const _component_CardContent = _resolveComponent("CardContent")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.toTitleCase(_ctx.category)), 1),
      _createVNode(_component_Button, {
        color: "secondary",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.addExpense()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AddIcon, { class: "w-5 h-5 mr-2" }),
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        _createVNode(_component_CardHeader, { class: "bg-gray-100 rounded-t-md" }, {
          default: _withCtx(() => [
            _createVNode(_component_BudgetTableHeaders, { headers: _ctx.tableHeaders }, null, 8, ["headers"])
          ]),
          _: 1
        }),
        _createVNode(_component_CardContent, null, {
          default: _withCtx(() => [
            (!_ctx.data.length)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode(_component_WarningIcon, { class: "w-8 h-8" }),
                  _createVNode("span", null, _toDisplayString(_ctx.toTitleCase(_ctx.category)) + " is empty.", 1)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
              return (_openBlock(), _createBlock("div", {
                key: item.id,
                class: 
						`grid grid-cols-2 sm:grid-cols-${_ctx.tableHeaders.length} gap-2 text-gray-700 py-4 even:bg-gray-100 items-center`
					
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (header, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: ["col-span-1", {
							'pl-2': index === 0,
							'hidden sm:block': ![
								'name',
								'actions',
								'vehicle',
							].includes(header),
						}],
                    key: index
                  }, [
                    (header !== 'actions')
                      ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.getExpenseValue(header, item)), 1))
                      : _createCommentVNode("", true),
                    (header === 'actions')
                      ? (_openBlock(), _createBlock("div", _hoisted_7, [
                          _createVNode(_component_Button, {
                            color: "secondary",
                            fab: "",
                            "onOn-click": $event => (_ctx.addExpense(item))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_EditIcon, { class: "w-4 h-4" })
                            ]),
                            _: 1
                          }, 8, ["onOn-click"]),
                          _createVNode(_component_Button, {
                            color: "danger",
                            fab: "",
                            onClick: $event => (_ctx.removeExpense(item.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_BanIcon, { class: "w-4 h-4 text-white" })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128 /* KEYED_FRAGMENT */))
              ], 2))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}